
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Notif from '@/extend/classes/Notif';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeNotif' })

export default class storeNotif extends VuexModule {
  // States
  private reccords: Notif[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get notifLoading (): boolean {
    return this.dataLoading;
  }
  private get notifRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get notifLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewNotif() {
    return (): Notif => { 
      return this.getNotif(0, true);
    }
  }

  
  public get getNotif () {
    return (id: number, canCreate = false): Notif => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Notif can't be 0")
        return new Notif();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Notif();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Notif.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromNotif(data.reccords[0] as Notif);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listNotif (): Notif[] {
    return this.reccords;
  }

  public get listConfigNotif (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mNotifRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mNotifClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mNotifLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mNotifLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Notif.fromJson(reccord as Notif));
    })
    Notif.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mNotifConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mNotifCreated (obj: Notif): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNotif(obj)) {
          api.fromNotif(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareNotif(obj)) {
            api.fromNotif(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mNotifUpdated (obj: Notif): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNotif(obj)) {
          api.fromNotif(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mNotifDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerNotif (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.notifRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerNotif(this.notifCreated, this.notifUpdated, this.notifDeleted);
          this.mNotifRegistered();
        } else {
          setTimeout(() => resolve(this.registerNotif(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.notifLoading && !this.notifLoaded) {
          this.mNotifLoading(true);
          return Notif.list(filter)
            .then((data: ListData) => {
              this.mNotifLoaded(data);
              this.mNotifLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredNotif (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.notifLoading) {
        this.mNotifLoading(true);
        return Notif.list(filter)
          .then((data: ListData) => {
            this.mNotifLoaded(data);
            this.mNotifLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public updateNotif (obj: Notif): Promise<Notif> {
    return new Promise((resolve, reject) => {
      return Notif.fromJson(obj).updateForStoreNotif()
        .then((reccords) => {
          this.mNotifUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteNotif (obj: Notif): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Notif.fromJson(obj).deleteForStoreNotif()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mNotifDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private notifCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNotifConfigUpdated(config)
    const obj = objConfig.obj as Notif;
    this.mNotifCreated(Notif.fromJson(obj));
  }

  @Action
  private notifUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNotifConfigUpdated(config)
    const obj = objConfig.obj as Notif;
    this.mNotifUpdated(Notif.fromJson(obj));
  }

  @Action
  private notifDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Notif;
    this.mNotifDeleted(obj.id);
  }
}
